import { render, staticRenderFns } from "./final-questions.vue?vue&type=template&id=1c52ff31&scoped=true&"
import script from "./final-questions.vue?vue&type=script&lang=js&"
export * from "./final-questions.vue?vue&type=script&lang=js&"
import style0 from "./final-questions.vue?vue&type=style&index=0&id=1c52ff31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c52ff31",
  null
  
)

export default component.exports